import $ from 'jquery';

$(function () {
	if($('.testimonial-slider').length) {
		const slider = tns({
			container: '.testimonial-slider',
			items: 1,
			slideBy: 'page',
			controlsPosition: 'bottom',
			nav: true,
			navPosition: 'bottom',
			autoplay: true,
			controlsContainer: ".controls",
			autoplayButtonOutput: false
		});
	}
});
